import { useEffect } from "react";
import { useTaxStore, useCurrentTaxInput } from "./store/useTaxStore";
import { calculateTax } from "./lib/taxCalculator";
import TaxHeader from "./components/TaxHeader";
import TaxPlannerSkeleton from "./components/TaxPlannerSkeleton";
import IncomeSection from "./components/IncomeSection";
import DeductionsSection from "./components/DeductionsSection";
import TaxSummarySidebar from "./components/TaxSummarySidebar";
import OptimizationTips from "./components/OptimizationTips";
import RecurringIncomeMonthlySection from "./components/RecurringIncomeMonthlySection";

export default function TaxPlannerPage() {
  const {
    viewYear,
    loadYearData,
    loadPreferences,
    enabledDeductions,
    loading,
    error,
  } = useTaxStore();
  const input = useCurrentTaxInput();
  const result = calculateTax(input, viewYear, enabledDeductions);

  useEffect(() => {
    loadPreferences();
  }, [loadPreferences]);

  useEffect(() => {
    loadYearData(viewYear);
  }, [viewYear, loadYearData]);

  return (
    <>
      <TaxHeader />

      {error && (
        <div className="mb-5 rounded-xl border border-destructive/30 bg-destructive/5 px-4 py-3 text-[13px] text-destructive">
          Failed to load tax data: {error}
        </div>
      )}

      {loading ? (
        <TaxPlannerSkeleton />
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {/* Left: inputs */}
          <div className="lg:col-span-7 space-y-5">
            <RecurringIncomeMonthlySection />
            <IncomeSection />
            <DeductionsSection />
            <OptimizationTips tips={result.tips} />
            {/* <YearComparison /> */}
          </div>

          {/* Right: sticky summary */}
          <div className="order-first lg:order-none lg:col-span-5">
            <div className="lg:sticky lg:top-4">
              <TaxSummarySidebar result={result} ceYear={viewYear} />
            </div>
          </div>
        </div>
      )}

      <div className="mt-8 pb-8 text-center text-[12px] text-muted-foreground">
        This calculation is an estimate only. Consult a tax professional before
        filing.
      </div>
    </>
  );
}
